import * as React from "react";
function SvgHourglassHalf({ title, titleId, ...props }) {
    return (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 62 62", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props },
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M46.5 56.833l-.026-15.5L36.167 31l10.307-10.36.026-15.473h-31v15.5L25.833 31 15.5 41.307v15.526h31zM20.667 19.375v-9.042h20.666v9.042L31 29.708 20.667 19.375z", fill: "#F2F3F4" })));
}
const MemoSvgHourglassHalf = React.memo(SvgHourglassHalf);
export default MemoSvgHourglassHalf;
